__turbopack_context__.v({
  "categoryBlock": "MenuCategoryBlocks-module-scss-module___m2Q5a__categoryBlock",
  "categoryContent": "MenuCategoryBlocks-module-scss-module___m2Q5a__categoryContent",
  "categoryImage": "MenuCategoryBlocks-module-scss-module___m2Q5a__categoryImage",
  "categoryIndicator": "MenuCategoryBlocks-module-scss-module___m2Q5a__categoryIndicator",
  "categoryLink": "MenuCategoryBlocks-module-scss-module___m2Q5a__categoryLink",
  "categoryTitle": "MenuCategoryBlocks-module-scss-module___m2Q5a__categoryTitle",
  "imageContainer": "MenuCategoryBlocks-module-scss-module___m2Q5a__imageContainer",
  "menuCategorySection": "MenuCategoryBlocks-module-scss-module___m2Q5a__menuCategorySection",
  "overlay": "MenuCategoryBlocks-module-scss-module___m2Q5a__overlay",
});
